export default __webpack_public_path__ + "static/media/section1_tool_bubble.8eff6769.svg";